const USER_LIMITS_GET = 'USER_LIMITS_GET'
const USER_LIMITS_GET_SUCCESS = 'USER_LIMITS_GET_SUCCESS'
const USER_LIMITS_GET_ERROR = 'USER_LIMITS_GET_ERROR'

const USER_LIMITS_UPDATE_CREDITS = 'USER_LIMITS_UPDATE_CREDITS'

export {
  USER_LIMITS_GET,
  USER_LIMITS_GET_SUCCESS,
  USER_LIMITS_GET_ERROR,
  USER_LIMITS_UPDATE_CREDITS,
}
